import { PureComponent } from 'react';

import BlackFridayScrollTop from './BlackFridayScrollTop.component';

import { debounce } from 'Util/Request';

export class BlackFridayScrollTopContainer extends PureComponent {
    state = {
        active: false
    }

    componentDidMount() {
        const SCROLL_DEBOUNCE_DELAY = 10;
        window.addEventListener('scroll', debounce(() => this.handleScroll(), SCROLL_DEBOUNCE_DELAY));
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    containerProps = () => {
        const { active } = this.state;

        return {
            active
        };
    };


    handleScroll() {
        const scrolled = document.documentElement.scrollTop;

        if (scrolled > 600) {
            this.setState({ active: true });
        } else if (scrolled <= 600) {
            this.setState({ active: false });
        }
    }

    render() {
        return <BlackFridayScrollTop { ...this.containerProps() } />
    }
}

export default BlackFridayScrollTopContainer;

